// extracted by mini-css-extract-plugin
export default {"eventDetail":"style_eventDetail__WPcCs","title":"style_title__qLY1c","content":"style_content__cg9UU"};